module.exports = new __parcel__URL__("magicarrow.e00e013d.png").toString();